import React from 'react';

import styles from './NewsBox.module.css';

const newsBox = props => {
  return (
    <div className={styles.Container}>
      <span className="material-icons">info</span> {props.info}
    </div>
  );
}

export default newsBox;
